class WorkerMessageType {
    static MAKE_ELEMENT = 'make_element'
    static CREATE_INIT = 'create_init'
    static RESIZE = 'resize'
    static EVENT = 'event'
    static DISPOSE = 'dispose'
}

export default WorkerMessageType